import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { MessageSquare } from "lucide-react";

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  // Hide on livestock shelter quote page (it has its own CTA)
  const isQuotePage = location.pathname === "/products/livestock-shelter";

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 15000); // 15 seconds

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible || isQuotePage) return null;

  return (
    <div className="md:hidden fixed bottom-4 left-3 right-3 z-50 animate-slide-up" data-testid="floating-cta">
      <Link to="/contact">
        <button className="w-full bg-[#E63946] hover:bg-[#D62839] text-white font-bold uppercase tracking-wider py-3 px-5 text-sm rounded-full shadow-2xl flex items-center justify-center gap-2 btn-glow transition-all">
          <MessageSquare size={18} />
          Get a Quote
        </button>
      </Link>
    </div>
  );
}
